// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__k4000","button__icon":"styles_button__icon__bY_qL","rotated":"styles_rotated__tRNOW"};